import React from "react";
import { CircleLogo } from "web/react/emo/circle-logo";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import { RailCardSerializer } from "web/types/serializers";

interface RelatedRailCardProps {
    candidate: RailCardSerializer;
    logoSize?: "xl" | "xxl";
}

export function RelatedRailCard({
    candidate,
    logoSize = "xl",
}: RelatedRailCardProps): React.ReactElement {
    return (
        <div data-testid="retailer-rail-card">
            <VStack spacing="xs" align="center">
                <a href={candidate.url}>
                    <CircleLogo
                        size={logoSize}
                        imageURL={candidate.image_url}
                        name={candidate.name}
                        altText={`${candidate.name} logo`}
                    />
                </a>
                <a href={candidate.url}>
                    <Text as="p" textStyle="body-s" color="secondary">
                        {candidate.name}
                    </Text>
                </a>
            </VStack>
        </div>
    );
}
